"use client"

import { Head, router } from "@inertiajs/react"

import { Button } from "@/components/ui/button"

interface ConsentProps {
  impressionId: number
  channel: string | null
  destinationName: string
  fields: string[]
  referPath: string
  backPath: string
}

// Friendly labels for the fields a warm handoff pre-fills.
const FIELD_LABELS: Record<string, string> = {
  declared_age: "your age",
  origin: "the playlist you came from",
}

export default function Consent({
  impressionId,
  channel,
  destinationName,
  fields,
  referPath,
  backPath,
}: ConsentProps) {
  const approve = () =>
    router.post(referPath, {
      impression_id: impressionId,
      channel: channel ?? "web",
      consent: true,
    })

  return (
    <>
      <Head title="Before you continue" />
      <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-6 px-6 text-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-primary text-2xl font-semibold">
            Before we connect you to {destinationName}
          </h1>
          <p className="text-tertiary text-md">
            To save you retyping, we can share a little about you. Nothing
            leaves without your say-so.
          </p>
        </div>

        <ul className="border-secondary flex w-full flex-col gap-2 rounded-xl border p-4 text-left">
          {fields.map((field) => (
            <li key={field} className="text-secondary text-sm">
              • {FIELD_LABELS[field] ?? field}
            </li>
          ))}
        </ul>

        <p className="text-quaternary text-xs">
          Only these, and only with {destinationName}.
        </p>

        <div className="flex w-full flex-col gap-3">
          <Button size="lg" onClick={approve}>
            Approve &amp; continue
          </Button>
          <Button
            size="lg"
            color="link-gray"
            onClick={() => router.visit(backPath)}
          >
            Not now
          </Button>
        </div>
      </main>
    </>
  )
}
